import { render, staticRenderFns } from "./OrgOnboardingStep2.vue?vue&type=template&id=6aa8d5f2&scoped=true"
import script from "./OrgOnboardingStep2.vue?vue&type=script&lang=js"
export * from "./OrgOnboardingStep2.vue?vue&type=script&lang=js"
import style0 from "./OrgOnboardingStep2.vue?vue&type=style&index=0&id=6aa8d5f2&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6aa8d5f2",
  null
  
)

export default component.exports